import { EventEmitter, Feature } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';
import { Events } from '@tencent/docs-titlebar-service';
import { saveComponentRevision } from '@src/js/common/ark-extensions/dc-components/docs-component-record';
import { ActiveType } from '@src/slide/application/service/history-manager/core/container';

@Feature()
export class SaveRevisionFeature extends BaseTitleBarFeature {
    constructor(private eventEmitter: EventEmitter) {
        super();
    }

    public saveRevision() {
        saveComponentRevision(() => this.getMenuManager()?._actionRevisionRecord({
            activeId: ActiveType.VERSION_TYPE,
        }));
        this.eventEmitter.emit(Events.HIDE_COOPERATION);
    }
}
